module.exports = __webpack_public_path__ + "static/media/preview_screen3.7bd7e829.png";